export default __webpack_public_path__ + "static/media/HamburgerDownArrow.1198b568.svg";